angular.module('picmonic-common').factory('QuestionOfTheDayResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/questionoftheday/:question_of_the_day_id',
      { question_of_the_day_id: '@question_of_the_day_id' },
      {
        update: { method: 'PUT', isArray: false },
      }
    );
  },
]);
